module.exports = __webpack_public_path__ + "7960a25ed21521665906c016205c6d17.png";